<template>
  <div class="content-builder">

    <div class="form-group">
      <QuillEditor :toolbar="toolbarOpts" :modules="editorModules" :contentType="'html'" v-model:content="content.text"/>
    </div>

    <div class="form-group">
      <label for="media" class="control-label">Image</label>

      <div class="input-group">
        <div class="input-group-prepend">
          <a data-input="image"  class="btn btn-primary text-white" data-lfm="image">
            <i class="fa fa-image-o"></i> Choose
          </a>
        </div>
        <input id="image" type="text" class="form-control" v-model="content.image">
      </div>
    </div>

  </div>
</template>

<script>
  import _ from 'lodash'
  import layoutMixin from '../../mixins/layout'
  import { EDITOR_CONFIG_BUTTONS_FULL } from '../../../common/constants'
  import { QuillEditor } from '@vueup/vue-quill'
  import '@vueup/vue-quill/dist/vue-quill.snow.css';

  export default {
    components: {
      QuillEditor
    },
    mixins: [layoutMixin],
    data() {
      return {
        toolbarOpts: EDITOR_CONFIG_BUTTONS_FULL
      }
    },
    methods: {
      setContent() {
        console.log('Full::setContent')
      },
      getValue() {
        this.content.image = $('#image').val()
        return this.content
      }
    }
  }
</script>
